import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import truncate from 'lodash/truncate';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import classNames from 'classnames';
import './NewProjectCard.css';
import cover from './cover.svg';
import { BID_REQUEST_EXPIRATION_TIME } from '../../../store/reducers/ProjectView';
import { Button } from '../../Button';

export const NewProjectCard = ({
  project,
  handleGoToProjectView,
  handleDiscardProject,
}) => {
  const bidTimeLeft = getBidTimeLeft(project.bid_info.last_bid_created_at);

  const isExpired = isBidRequestExpired(bidTimeLeft);

  const projectName = project.project_name
    ? truncate(project.project_name, { length: 25 })
    : 'Real Estate Video';

  const [open, setOpenPopup] = useState(false);

  return (
    <div className="col-12 col-md-6 col-lg-4 mb-4">
      <div className="card border-0 card-project card-project-pending">
        <div
          className={`card-img-top card-img-top-bg position-relative ${classNames(
            { 'cursor-pointer': !isExpired, 'cursor-not': isExpired },
          )}`}
          style={{
            backgroundImage: `url(${project.project_picture || cover})`,
          }}
          onClick={() => !isExpired && handleGoToProjectView(project)}
        />
        <div className="card-body">
          <div
            className="row justify-content-between"
            style={{
              minHeight: '27px',
            }}
          >
            <div className="col-6">
              <h4 className="t-18 text-darkgreen">{projectName}</h4>
            </div>
            <div className="col-2">
              <div
                className="cursor-pointer delete-project"
                onClick={() => setOpenPopup(!open)}
              >
                <i className="icon icon-clearer text-gray-light t-20" />
              </div>
            </div>
          </div>
          <p className="t-12 text-gray-light font-weight-mid">
            {`Last Update: ${createFormattedDate(project.updated_at)(
              'DD MMM YYYY',
            )}`}
          </p>
        </div>
      </div>

      <Modal
        isOpen={open}
        toggle={() => setOpenPopup(!open)}
        centered
        className="modal-ml dashboard__content--project-actions-discard--confirm"
      >
        <ModalHeader toggle={() => setOpenPopup(!open)}>
          <span className="t-18 font-weight-extrabold">
            Discard {projectName}
          </span>
        </ModalHeader>
        <ModalBody>
          <p className="text-gray-light t-15">
            Are your sure? All materials will be deleted. You will not be
            <br />
            able to undo this.
          </p>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end border-0">
          <Button
            transparent
            className="t-14 px-4 text-danger"
            inline
            title="Delete"
            onClick={() => {
              handleDiscardProject(project);
              setOpenPopup(!open);
            }}
          />
          <Button
            transparent
            className="t-14 px-4 text-gray"
            inline
            title="Cancel"
            onClick={() => setOpenPopup(!open)}
          />
        </ModalFooter>
      </Modal>
    </div>
  );
};

const isBidRequestExpired = ({ hours, minutes, seconds }) =>
  hours < 0 || minutes < 0 || seconds < 0;

const getBidTimeLeft = lastBidDate => {
  const bidRequestExpired = moment(lastBidDate, 'YYYY-MM-DD HH:mm:ss Z').add(
    BID_REQUEST_EXPIRATION_TIME,
    'hours',
  );

  const now = moment();

  const duration = moment.duration(bidRequestExpired.diff(now));

  return {
    hours: duration.get('hours'),
    minutes: duration.get('minutes'),
    seconds: duration.get('seconds'),
  };
};

const createFormattedMoment = date => moment(date, 'YYYY-MM-DD');

const createFormattedDate = date => format =>
  createFormattedMoment(date).format(format);

NewProjectCard.propTypes = {
  project: PropTypes.shape({
    project_name: PropTypes.string,
    updated_at: PropTypes.string,
    price_selected: PropTypes.number,
    bid_info: PropTypes.shape({
      last_bid_created_at: PropTypes.string,
    }),
    bids: PropTypes.array,
  }),
  handleGoToProjectView: PropTypes.func.isRequired,
  handleDiscardProject: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/DashboardCard/NewProjectCard/NewProjectCard.js